import { SmartReviewOptionBody } from './SmartReviewOption.Body';
import { SmartReviewOptionFooter } from './SmartReviewOption.Footer';

/** Compound component for the "SmartReview" step. */
export const SmartReviewOption = {
  Body: SmartReviewOptionBody,
  Footer: SmartReviewOptionFooter,
};
